import React, { createContext, useContext } from 'react';
import AnalyticsService from 'app/services/analytics/AnalyticsService';
import { useConstant } from 'app/utils/react';

const AnalyticsServiceContext = createContext<AnalyticsService | null>(null);

export const useAnalyticsService = () => useContext(AnalyticsServiceContext);

const AnalyticsServiceProvider: React.FunctionComponent = ({ children }) => {
  const analyticsService = useConstant(() => new AnalyticsService());

  return (
    <AnalyticsServiceContext.Provider value={analyticsService}>
      {children}
    </AnalyticsServiceContext.Provider>
  );
};

export default AnalyticsServiceProvider;
